var _document_querySelector;
import { Api } from './insightsTypes';
export var api = new Api({
    baseURL: window.location.origin,
    headers: {
        'X-CSRF-Token': (_document_querySelector = document.querySelector('[name=csrf-token]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.content
    }
});
